import { createLoginToken } from 'models';
import { useCallback } from 'react';
import { message } from 'ui';
import { getLoginToken } from 'features/auth';
import { routes } from '../routes';

export const generateEhrPortalUrl = (path: string) => `${import.meta.env.VITE_APP_EHR_PORTAL_URL}${path}`;

export const useEhrPortalRedirect = () =>
  useCallback(async (redirectUrl: string) => {
    const ehrUrl = new URL(generateEhrPortalUrl(routes.tokenLogin));

    try {
      const response = await getLoginToken();
      const { loginToken } = createLoginToken(response.data);
      ehrUrl.searchParams.append('token', loginToken);
      ehrUrl.searchParams.append('redirectUrl', redirectUrl);
    } catch {
      message.error('Cannot generate link with login token');
    }

    return window.open(ehrUrl.toString(), '_blank');
  }, []);
